
























































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  groupCompareSynthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import MiniTable from '../../_components/MiniTable.vue'

@Component({
  components: {
    MiniTable
  }
})
export default class extends Vue {
  private frirstChartData: any = {};
  private barDataArray: Array<object> = [];

  private mainArr = [];
  private subArr = [];
  private classroomName: any = '';
  private sexName: any = '';
  private compareName: any = '';
  created() {
    if (!this.$route.query.searchParams) return
    let params = JSON.parse(this.$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(params))

    const classroomNames: any = []
    const sexNames: any = []
    const compareNames: any = []

    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    this.$enums.classroomTypes.map((v: any) => {
      if (params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
      }
    })
    this.compareName = compareNames.join('、')
    groupCompareSynthEZAvgScore(params).then((res) => {
      res.data.synthEZAvgScore.details.map((item: any) => {
        item.values.pop()
        item.valueDescs.pop()
      })
      this.frirstChartData = res.data.synthEZAvgScore
      this.barDataArray =
        res.data.barChart.map((item: any) => {
          item.details.map((_item: any) => {
            _item.values.pop()
            _item.valueDescs.pop()
          })
          return item
        }) || []

      this.mainArr = this.barDataArray.slice(0, 5)
      this.subArr = this.barDataArray.slice(5, 8)
    })
  }
}
